import { frontendURL } from 'dashboard/helper/URLHelper';
import SimulacaoDigitacaoIndex from './Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/simulacao-digitacao'),
    name: 'simulacao_digitacao_index',
    component: SimulacaoDigitacaoIndex,
    meta: {
      permissions: [
        'administrator', 'supervisor', 'agent', 'operacional',
        'qualidade', 'ouvidoria', 'juridico', 'custom_role',
      ],
    },
  },
];

export default { routes };
